module.exports = __webpack_public_path__ + "static/media/banner-home-5.940c5de8.jpg";